import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Layers } from "appworks/graphics/layers/layers";
import { BitmapText } from "appworks/graphics/pixi/bitmap-text";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { GamevyAutoSpinCountControl } from "../controls/gamevy-auto-spin-count-control";

export class GamevyAutoSpinCountControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return this.getText(layer) != null;
    }

    public build(layer: Layers): AbstractControl[] {
        return [new GamevyAutoSpinCountControl(this.getText(layer))];
    }

    protected getText(layer: Layers): FlexiText | BitmapText {
        return layer.getFlexiText("gamevy_autoplay_count_value") ||
            layer.getBitmapText("gamevy_autoplay_count_value");
    }
}
